export { InstagramSectionContainer as InstagramSection } from './InstagramSection.container';
